import { ScheduleType } from 'types/schedule'
import { useMemo } from 'react'
import { DaysOfWeek } from 'lib/daysOfWeek'
const daysOfWeek = new DaysOfWeek()

export const useDaysOfWeekName = (schedule: ScheduleType): string => {
  return useMemo(() => {
    if (schedule.days_of_week.length > 0) {
      return schedule.days_of_week
        .sort((a, b) => (daysOfWeek.getOrder(a) < daysOfWeek.getOrder(b) ? -1 : 1))
        .map((dayOfWeek) => daysOfWeek.getShortName(dayOfWeek))
        .join('・')
    } else {
      return '受渡可能日無し'
    }
  }, [schedule])
}

export default useDaysOfWeekName
